import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import Image from 'next/image'
import { getItem } from '@/lib/utils'

const resource = createResource({
  en: {
    title: 'Funding Portfolio Quality',
    title1: 'Performing',
    title2: 'Watch list',
    title3: 'Substandard',
    title4: 'Doubtful',
    title5: 'Non-Performing',
    desc1: '0%',
    desc2: '0%',
    desc3: '0%',
    desc4: '0%',
    desc5: '0%',
  },
  id: {
    title: 'Tingkat Kualitas Pendanaan',
    title1: 'Lancar',
    title2: 'Dalam Perhatian Khusus',
    title3: 'Kurang Lancar',
    title4: 'Diragukan',
    title5: 'Macet',
    desc1: '0%',
    desc2: '0%',
    desc3: '0%',
    desc4: '0%',
    desc5: '0%',
  },
})

const Funding = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const resultTkp = typeof window !== 'undefined' ? getItem('resultTkp') : null

  const FeatureList = [
    {
      img: '/images/home/performing.png',
      title: t('title1'),
      desc: typeof resultTkp?.performing === 'number' && !isNaN(resultTkp.performing) ? `${resultTkp?.performing}%` : t('desc1'),
    },
    {
      img: '/images/home/watchlist.png',
      title: t('title2'),
      desc: typeof resultTkp?.watchList === 'number' && !isNaN(resultTkp.watchList) ? `${resultTkp?.watchList}%` : t('desc2'),
    },
    {
      img: '/images/home/substandard.png',
      title: t('title3'),
      desc: typeof resultTkp?.substandard === 'number' && !isNaN(resultTkp.substandard) ? `${resultTkp?.substandard}%` : t('desc3'),
    },
    {
      img: '/images/home/doubtful.png',
      title: t('title4'),
      desc: typeof resultTkp?.doubtful === 'number' && !isNaN(resultTkp.doubtful) ? `${resultTkp?.doubtful}%` : t('desc4'),
    },
    {
      img: '/images/home/non-performing.png',
      title: t('title5'),
      desc: typeof resultTkp?.nonPerforming === 'number' && !isNaN(resultTkp.nonPerforming) ? `${resultTkp?.nonPerforming}%` : t('desc5'),
    },
  ]
  return (
    <FeatureStyle>
      <h2 className="title">{t('title')}</h2>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '272px' }}>
        {width >= 1000 ? (
          FeatureList?.map((item, index) => (
            <Reveal key={index} delay={200 + index * 80} animation={Animation.FadeIn}>
              <div className="item">
                <div className="img">
                  <Image src={item.img} alt={item.title} width={40} height={40} quality={85} placeholder="empty" />
                </div>
                <div className="subtitle">{item.title}</div>
                <div className="des">{item.desc}</div>
              </div>
            </Reveal>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }}>
            {FeatureList?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <Image src={item.img} alt={item.title} width={40} height={40} quality={85} placeholder="empty" />
                  </div>
                  <div className="subtitle">{item.title}</div>
                  <div className="des">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </FeatureStyle>
  )
}

export default Funding

const FeatureStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 64px auto 0;
    text-align: center;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      margin-bottom: 32px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 auto;
      .item {
        width: 272px;
        height: 132px;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.03);
        border-radius: 8px;
        border: 1px solid #e6eaf0;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        margin-bottom: 50px;
        .img {
          margin: 6px 0 5px 0;
          width: 40px;
          height: 40px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #757575;
          line-height: 19px;
          margin-bottom: 8px;
        }
        .des {
          font-size: 32px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 600;
          color: #1cc814;
          line-height: 38px;
          margin-bottom: 16px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 104px 150px 0px;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      margin-bottom: 48px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 220px;
        height: 132px;
        background: #ffffff;
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.03);
        border-radius: 8px;
        border: 1px solid #e6eaf0;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        margin-bottom: 32px;
        .img {
          margin: 6px 0 5px 0;
          width: 40px;
          height: 40px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #757575;
          line-height: 19px;
          margin-bottom: 8px;
        }
        .des {
          font-size: 32px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 600;
          color: #1cc814;
          line-height: 38px;
          margin-bottom: 16px;
        }
      }
    }
  }
`
